import { PropsWithChildren, ReactNode } from 'react';
import * as formStyles from '../styles/styles.module.scss';
import * as baseStyles from '../../../styles/baseStyles.module.scss';
import * as styles from './styles/styles.module.scss';

interface WrapperProps {
  text?: {
    headText?: ReactNode;
    stepText?: ReactNode;
  };
  foot?: ReactNode;
  showStepText?: boolean;
  extraContainerClass?: string;
}

// thinking this component might not be necessary 2022-05-01 junger
const Wrapper = ({ text, foot, children, showStepText, extraContainerClass }: PropsWithChildren<WrapperProps>) => (
  <div>
    <div className={`${baseStyles.container} ${formStyles.container} ${styles.wrapper} ${extraContainerClass}`}>
      <div className={formStyles.head}>
        <div className={formStyles.subHead}>{text.headText}</div>
        <div className={formStyles.step}>{showStepText ? text.stepText : ''}</div>
      </div>
      {children}
      {foot && <div className={formStyles.foot}>{foot}</div>}
    </div>
  </div>
);

Wrapper.defaultProps = {
  foot: <div />,
  showStepText: false,
  extraContainerClass: ''
};

export default Wrapper;
